'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementHelper = require('../../../../common/elements/elementHelper');

exports.default = function (_ref) {
    var monitor = _ref.monitor;

    var item = monitor.getItem();
    return !item.element || !item.draggedElements.every(_elementHelper.isLine);
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/preventLinePredicate.js
// module id = 301
// module chunks = 0